import { useTranslation } from "react-i18next";
import * as yup from "yup";

const useFoldersStructureRootFolderSchema = () => {
    const { t } = useTranslation();

    return yup.object({ folderName: yup.string().required(t("messages.inputMsgs.required")) });
};

export default useFoldersStructureRootFolderSchema;
